<template>
	<div>
		<div class="common-header">
			<div class="header-left">
				<img src="../assets/index-logo.png" style="width: 60px;height: 60px;float: left;" alt="" />
				<div style="color: #fff;font-size: 25px;margin-left: 10px;float: left;">石家庄道路运输行业协会报名培训后台管理系统</div>
			</div>
			<div class="header-right">
				<span style="float: right;cursor: pointer;" @click="loginOut()">退出</span><i class="el-icon-switch-button" style="font-size: 18px !important;margin-left: 12px;margin-top: 22px;float: right;cursor: pointer;margin-right: 2px;"></i> <span style="float: right;">欢迎你，{{username}}</span>
			</div>
		</div>
		<div class="common-container">
			<div style="width: 200px;position: relative;">
				<div style="height: 100%;width: 1px;background: #eee;position: absolute;top: 0;right: 0;"></div>
				<el-menu :default-active="activeName" router class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
					<el-menu-item index="/Index"  @click="handleMenuItemClick">
						<i class="el-icon-folder"></i>
						<span slot="title">会员单位管理</span>
					</el-menu-item>
					<!-- <el-menu-item index="/CompanyChangeIndex">
						<i class="el-icon-document-copy"></i>
						<span slot="title">企业变更记录</span>
					</el-menu-item> -->
					<el-menu-item index="/SignUpRecord" @click="handleMenuItemClick">
						<i class="el-icon-document"></i>
						<span slot="title">报名记录</span>
					</el-menu-item>
					<el-menu-item index="/StudentInfoPage"  @click="handleMenuItemClick">
						<i class="el-icon-user"></i>
						<span slot="title">学员信息</span>
					</el-menu-item>
					<el-menu-item index="/MajorManagePage"  @click="handleMenuItemClick">
						<i class="el-icon-setting"></i>
						<span slot="title">专业类别管理</span>
					</el-menu-item>
					<el-menu-item index="/BillList"  @click="handleMenuItemClick">
						<i class="el-icon-s-order"></i>
						<span slot="title">发票申请记录</span>
					</el-menu-item>
					<el-menu-item index="/PaymentFlow"  @click="handleMenuItemClick">
						<i class="el-icon-refresh"></i>
						<span slot="title">支付流水</span>
					</el-menu-item>
					<el-menu-item index="/SetUp"  @click="handleMenuItemClick">
						<i class="el-icon-data-board"></i>
						<span slot="title">报名设置</span>
					</el-menu-item>
				</el-menu>
			</div>
			<div style="flex: 1;height: 100%;overflow: auto;overflow-x: hidden;padding:10px 20px;box-sizing: border-box;">
				<keep-alive>
					<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: '/Index',
				username: ''
			}
		},
		mounted() {
			let username = sessionStorage.getItem('username')
			this.username = sessionStorage.getItem('username')
			console.log(username)
			if(username == null || username == "" || username == undefined || username == "null") {
				this.$router.push('/Login');
			}
		},
		methods: {
			handleMenuItemClick(){
				this.$baseHttp();
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			loginOut() {
				sessionStorage.setItem('token',null)
				sessionStorage.setItem('username', null);
				this.$router.push('/Login')
			},
		}
	}
</script>

<style lang="less">
	.common-header {
		height: 60px;
		line-height: 60px;
		background: rgb(64, 158, 255);
		display: flex;
		.header-left {
			flex: 1;
			padding-left: 20px;
		}
		.header-right {
			flex: 1;
			color: #fff;
			text-align: right;
			padding-right: 20px;
			display: table-cell;
			vertical-align: middle;
		}
	}
	
	.common-container {
		height: calc( 100vh - 60px);
		display: flex;
	}
	
	.is-active {
		background: rgb(235, 245, 255) !important;
	}
</style>